import { Fragment, useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const IconArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="#bcb9be"
    style={{ transform: 'rotate(-90deg)' }}
    viewBox="40 45 200 200"
  >
    <path d="M150.6 99h16.2c2.5 0 4.7 1.4 5.9 3.6 1.1 2.2.9 4.8-.5 6.8L143 149.7c-.2.3-.2.6 0 .9l29.3 40.3c1.5 2 1.7 4.6.5 6.9-1.1 2.2-3.4 3.6-5.9 3.6h-16.4c-2.1 0-4.1-1-5.3-2.7L113 154.1a6.45 6.45 0 010-7.7l32.3-44.6c1.2-1.8 3.2-2.8 5.3-2.8z"></path>
  </svg>
)

const Accordion = ({ title, content, isActive }) => {
  const [active, setActive] = useState(false)
  const [height, setHeight] = useState('0')

  const containerContent = useRef(null)

  const toggleActive = () => {
    setActive(state => !state)
    setHeight(active ? 0 : `${containerContent.current.scrollHeight}px`)
  }

  return (
    <Fragment>
      <S.TitleContainer onClick={toggleActive}>
        <Text>{title}</Text>
        <IconArrow />
      </S.TitleContainer>

      <S.ContentContainer style={{ maxHeight: height }} ref={containerContent}>
        <S.Content
          dangerouslySetInnerHTML={{
            __html: content
          }}
        />
      </S.ContentContainer>
    </Fragment>
  )
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isActive: PropTypes.bool
}

Accordion.defaultProps = {
  isActive: false
}

export default Accordion
